"use client";

import { defaultLocale, locales } from "@forestsync/i18n";
import { setUserLocale } from "@forestsync/i18n/actions";
import {
  Group,
  LanguageSelector,
  ThemeSwitcher,
  CountryFlag,
} from "@forestsync/ui";
import { useState } from "react";

interface PreferencesProps {
  size?: "sm" | "md" | "lg" | "xs" | "xl";
}

export default function Preferences({ size = "lg" }: PreferencesProps) {
  const [currentLocale, setCurrentLocale] = useState(defaultLocale);

  const handleLocaleChange = async (locale: string | null) => {
    if (locale) {
      await setUserLocale(locale);
      setCurrentLocale(locale);
    }
  };

  // Add flag components to locales for the LanguageSelector
  const localesWithFlags = locales.map((locale) => ({
    ...locale,
    flag: locale.countryCode ? (
      <CountryFlag
        countryCode={locale.countryCode}
        width={16}
        height={12}
        className="inline-block"
      />
    ) : undefined,
  }));

  return (
    <Group gap={"xs"}>
      <ThemeSwitcher size={size} variant="subtle" />

      <LanguageSelector
        locales={localesWithFlags}
        currentLocale={currentLocale}
        onLocaleChange={handleLocaleChange}
        displayVariant="icon"
        size={size}
        variant="subtle"
      />
    </Group>
  );
}
